module.exports = __webpack_public_path__ + "img/n8y.0685bf38.png";